import shouldLevelUpTierLoyaltyUtil from 'modules/loyalty/utils/should-level-up-tier'
import isGoldTierLoyaltyUtil from 'modules/loyalty/utils/is-gold-tier'
import isDiamondTierLoyaltyUtil from 'modules/loyalty/utils/is-diamond-tier'
import getLoyaltyTierNameProductVariantUtil from 'modules/gift/utils/get-loyalty-tier-name'

/**
 * @param props
 * @param props.loyaltyTierName
 * @param props.isEligibleToTemporaryUnlockedSamples
 * @param props.hasReachedGoldSamplesLimitTemporaryUnlockedSamples
 * @param props.hasReachedDiamondSamplesLimitTemporaryUnlockedSamples
 * @param {ProductVariantCollection} props.productVariant
 * @return {*|boolean}
 */
export default function isUnlockedProductVariantSelectorUtil (props) {
  const {
    loyaltyTierName,
    isEligibleToTemporaryUnlockedSamples,
    hasReachedGoldSamplesLimitTemporaryUnlockedSamples,
    hasReachedDiamondSamplesLimitTemporaryUnlockedSamples,
    isSelfGifting
  } = props

  /**
   * @type {ProductVariantCollection}
   */
  const productVariant = props.productVariant
  const productLoyaltyTierName = getLoyaltyTierNameProductVariantUtil(productVariant)
  const shouldLevelUp = shouldLevelUpTierLoyaltyUtil(loyaltyTierName, productLoyaltyTierName)

  const res = !!(
    isSelfGifting ||
    !shouldLevelUp ||
    (
      isEligibleToTemporaryUnlockedSamples &&
      (
        (
          isGoldTierLoyaltyUtil(productLoyaltyTierName) &&
          !hasReachedGoldSamplesLimitTemporaryUnlockedSamples
        ) ||
        (
          isDiamondTierLoyaltyUtil(productLoyaltyTierName) &&
          !hasReachedDiamondSamplesLimitTemporaryUnlockedSamples
        )
      )
    )
  )

  // const debugProps = {
  //   isSelfGifting,
  //   loyaltyTierName,
  //   shouldLevelUp,
  //   isEligibleToTemporaryUnlockedSamples,
  //   hasReachedGoldSamplesLimitTemporaryUnlockedSamples,
  //   hasReachedDiamondSamplesLimitTemporaryUnlockedSamples,
  //   productLoyaltyTierName,
  //   res
  // }
  // logUtil('isUnlockedProductVariantSelectorUtil').debug('debugProps=', debugProps)

  return res
}
